import { Navigate, useParams } from 'react-router-dom';
import { MarketingDetailPage } from '@/modules/marketing/components/marketing-detail-page';
import { PRODUCTS } from '@/modules/marketing/components/product-visuals';

export function ProductDetailPage() {
    const { slug } = useParams<{ slug: string }>();
    const product = PRODUCTS.find((p) => p.key === slug);

    if (!product) {
        return <Navigate to="/" replace />;
    }

    return (
        <MarketingDetailPage
            backLabel="Products"
            backHref="/#products"
            visual={product.visual}
            content={{
                eyebrow: product.eyebrow,
                icon: product.icon,
                gradient: product.gradient,
                title: product.title,
                tagline: product.description,
                description: product.longDescription,
                bullets: product.bullets,
            }}
        />
    );
}
